import { useMemo } from 'react';
import {
  TierFeatureKey,
  buildOrgEntitlements,
  hasEntitlement,
  type OrgEntitlements,
} from '@court-sync/shared';
import { useClubModuleAccess } from '@/hooks/useClubModuleAccess';
import { useManagementDashboardFeatureAccess } from '@/hooks/useFeatureAccess';

export function useMatchPlayAccess(): {
  hasAccess: boolean;
  isLoading: boolean;
  orgEntitlements: OrgEntitlements;
} {
  const { entitlements, isLoading: clubLoading } = useClubModuleAccess();
  const { currentTier, tierResolved } = useManagementDashboardFeatureAccess(TierFeatureKey.MATCH_PLAY);

  return useMemo(() => {
    const orgEntitlements: OrgEntitlements =
      entitlements ?? buildOrgEntitlements({ clubManagement: false, tier: 'starter' });
    const hasAccess = hasEntitlement(orgEntitlements, TierFeatureKey.MATCH_PLAY, currentTier);

    return {
      hasAccess,
      isLoading: clubLoading || !tierResolved,
      orgEntitlements,
    };
  }, [entitlements, clubLoading, currentTier, tierResolved]);
}
